export default __webpack_public_path__ + "a949c38273d56432daaa7762c5eb945d.ttf";